<script lang="ts">import { getNotificationUIData } from "../helpers/content";
import Chevron from "../icons/chevron.svg";
import { FeatureSet, stateFeatureSet, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import { ReadIcon } from "@infinitro/icons";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
let { notification } = $props();
let showMore = $state(false);
let uiData = $derived(getNotificationUIData(notification));
function formatDate(date) {
	return date.toLocaleString(undefined, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	});
}
function toggleShowMore() {
	showMore = !showMore;
}
let useAlternative2 = $derived($stateUi.notifications.notificationsStyle === "alternative2");
</script>

{#if uiData && uiData.title}
	<div class="notification">
		<InfoCard
			width="100%"
			withoutBorder
			customStylesCard="background-image: var(--gradient-alternative-2), linear-gradient(to top, rgba(24, 31, 69, 1) 0%, rgba(24, 31, 69, 1) 58%, rgba(255, 255, 255, 0.22) 100%);"
		>
			<div class="notification-item">
				<Text type="subtitle" subtitleSize="large" textAlign="start">
					{uiData.title}
				</Text>

				<div class="d-flex">
					{#if uiData.date}
						<Text type="body" bodySize="small" textColor="gray">
							{formatDate(new Date(uiData.date))}
						</Text>
					{/if}
					{#if $stateFeatureSet === FeatureSet.Preview}
						<!-- {#if !uiData.read}
								<div class="active-badge">
									<span>
										{$t(Verbiage.new)}
									</span>
								</div>
							{/if} -->
					{/if}
				</div>
				{#if $stateFeatureSet === FeatureSet.Preview}
					<!-- {#if uiData.image}
							<img src={uiData.image} alt={uiData.title} class="notification-image" />
						{/if} -->
				{/if}
				{#if uiData.description}
					<Text type="body" bodySize="small" textColor="gray">
						{showMore ? uiData.description : uiData.description.slice(0, 60) + '...'}
					</Text>
					<div class="d-flex-end">
						<button class="show-more-btn" onclick={toggleShowMore}>
							{!showMore ? $t(Verbiage.show_more) : $t(Verbiage.hide)}
							<img src={Chevron} alt={$t(Verbiage.icon_alt, 'alts')} class:rotate={showMore} />
						</button>
					</div>
				{/if}
				<div class="divider"></div>
				<div class="d-flex">
					<!-- eslint-disable svelte/no-navigation-without-resolve -- toSiteUrl helper -->
					<a
						href={toSiteUrl(uiData.url, $loggedIn)}
						class="view-all-btn"
						class:view-all-btn-alternative2={useAlternative2}
					>
						{$t(Verbiage.view_all)}
						<svg
							class="chevron-image"
							width="10"
							height="6"
							viewBox="0 0 10 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							aria-hidden="true"
						>
							<path
								d="M0.762538 0.958641C1.07634 0.693758 1.53541 0.693758 1.84921 0.958641L5 3.61828L8.15079 0.958641C8.46459 0.693758 8.92366 0.693757 9.23746 0.958641C9.63613 1.29516 9.63613 1.90946 9.23746 2.24599L5.65294 5.27175C5.2923 5.57608 4.7077 5.57608 4.34706 5.27175L0.762538 2.24599C0.363873 1.90947 0.363873 1.29516 0.762538 0.958641Z"
								fill="currentColor"
							/>
						</svg>
					</a>
					<!-- eslint-enable svelte/no-navigation-without-resolve -->
					{#if $stateFeatureSet === FeatureSet.Preview}
						<button class="mark-as-read-btn">
							{$t(Verbiage.mark_as_read)}
							<ReadIcon />
						</button>
					{/if}
				</div>
			</div>
		</InfoCard>
	</div>
{/if}

<style>
	.notification-item {
		display: flex;
		height: 100%;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		gap: 0.5rem;
}
	.d-flex {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
}
	.d-flex-end {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: flex-end;
}
	.notification-image {
		width: 100%;
}
	.show-more-btn {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-style: none;
		background-color: transparent;
		font-size: 12px;
}
	.view-all-btn {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		font-size: 12px;
		color: var(--color-primary-500);
}
	.view-all-btn-alternative2 {
		color: var(--color-text-100);
}
	.mark-as-read-btn {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-style: none;
		background-color: transparent;
		font-size: 12px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		opacity: 0.5;
}
	.mark-as-read-btn:hover {
		opacity: 1;
}
	img {
		transition: transform 0.6s ease;
	}
	.rotate {
		transform: rotate(180deg);
	}
	.divider {
		margin-top: 0.25rem;
		margin-bottom: 0.25rem;
		height: 1px;
		width: 100%;
		background-color: var(--color-neutral-900);
}
	.active-badge {
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		padding: 0.5rem;
		font-size: 0.6rem;
		font-weight: 900;
		text-transform: uppercase;
		line-height: 0;
		--tw-text-opacity: 1;
		color: rgb(0 0 0 / var(--tw-text-opacity, 1));
		background: var(--gradient-primary);
		font-family: var(--font-main);
}
	.notification {
		margin-top: 0.75rem;
		margin-bottom: 0.75rem;
}
	.chevron-image {
		transform: rotate(270deg);
	}
</style>
